var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgReceipt = function SvgReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.135a1 1 0 011.55-.836l.09.068L6 3.5l1.4-1.05a1 1 0 011.09-.072l.11.072L10 3.5l1.4-1.05a1 1 0 011.09-.072l.11.072L14 3.5l1.4-1.05a1 1 0 011.09-.072l.11.072L18 3.5l1.36-1.133a1 1 0 011.634.655l.006.113v17.73a1 1 0 01-1.55.836l-.09-.068L18 20.5l-1.4 1.05a1 1 0 01-1.09.072l-.11-.072L14 20.5l-1.4 1.05a1 1 0 01-1.09.072l-.11-.072L10 20.5l-1.4 1.05a1 1 0 01-1.09.072l-.11-.072L6 20.5l-1.36 1.133a1 1 0 01-1.634-.655L3 20.865V3.135zM12 13H8a1 1 0 100 2h4a1 1 0 000-2zm4-4H8a1 1 0 00-.117 1.993L8 11h8a1 1 0 00.117-1.993L16 9z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};

export default SvgReceipt;